import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { BarChart3, ChevronDown, ChevronUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SERIES = [
  { code: 'annuel', label: 'Annuelle', color: '#0284c7' },
  { code: 'nominative', label: 'Nominative', color: '#059669' },
  { code: 'archos', label: 'ARCHOS', color: '#7c3aed' },
  { code: 'avenant', label: 'Avenant', color: '#d97706' },
];
const MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
const libMois = (k) => `${MOIS[Number(k.slice(5)) - 1]} ${k.slice(2, 4)}`;
const eur = (v) => `${Math.round(v || 0).toLocaleString('fr-FR')} €`;

const Graphique = ({ titre, data, champ, format, testId }) => (
  <div className="rounded-xl border bg-white p-4" data-testid={testId}>
    <p className="text-sm font-semibold text-gray-700 mb-2">{titre}</p>
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="libelle" tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} tickFormatter={format} width={70} />
        <Tooltip formatter={(v) => format(v)} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        {SERIES.map((s) => <Bar key={s.code} dataKey={`${s.code}_${champ}`} name={s.label} stackId="a" fill={s.color} />)}
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export const EvolutionDispositifs = ({ getAuthHeader }) => {
  const [ouvert, setOuvert] = useState(false);
  const [res, setRes] = useState(null);
  useEffect(() => {
    if (!ouvert || res) return;
    axios.get(`${API}/rcds-dashboard/evolution-dispositifs`, { headers: getAuthHeader() })
      .then((r) => setRes(r.data)).catch(() => setRes({ mois: [] }));
  }, [ouvert, res, getAuthHeader]);
  const data = (res?.mois || []).map((m) => ({
    libelle: libMois(m.mois),
    ...Object.fromEntries(SERIES.flatMap((s) => [[`${s.code}_nombre`, m[s.code].nombre], [`${s.code}_encaisse`, m[s.code].encaisse]])),
  }));
  return (
    <div className="space-y-3" data-testid="evolution-dispositifs">
      <button type="button" onClick={() => setOuvert(!ouvert)} className="flex items-center gap-2 text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors" data-testid="evolution-dispositifs-toggle">
        <BarChart3 className="h-4 w-4" /> Évolution mensuelle par dispositif {ouvert ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {ouvert && !res && <p className="text-sm text-gray-500">Chargement…</p>}
      {ouvert && res && (
        <>
          <div className="grid lg:grid-cols-2 gap-4">
            <Graphique titre="Souscriptions créées par mois" data={data} champ="nombre" format={(v) => v} testId="graph-souscriptions" />
            <Graphique titre="Montant encaissé par mois de paiement" data={data} champ="encaisse" format={eur} testId="graph-encaisse" />
          </div>
          {res.sans_date > 0 && <p className="text-xs text-gray-500" data-testid="evolution-sans-date">{res.sans_date} souscription(s) sans date de création ne figurent pas dans le graphique des souscriptions.</p>}
        </>
      )}
    </div>
  );
};
